import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';
import { Country, CountryDto } from '@emi/shared/models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: "root"
})

export class CountryService {
  constructor(private httpService : HttpService) { }

  public getCountries(filterData: any): Observable<CountryDto> {
    if(filterData.filters.countryIds.length > 0)
    {
      return this.httpService.postHttp<CountryDto>(Constants.ServiceConstants.COUNTRIES, filterData)
    }
    else{
      return this.httpService.getHttp<Country[]>(Constants.ServiceConstants.COUNTRIES).pipe(map(x => {return {results: x}}))
    }
  }
}
